// Single source of truth for the Creator Scripts version badge shown
// across every page and the sidebar. Bump here only — every page imports
// this instead of hardcoding its own copy (10 separate copies used to
// drift independently before this file existed).
//
// NOTE ON NUMBERING: this session renumbered the working sequence to
// v0.2.1-v0.2.6 (sequential patch bumps, since none of the work crossed a
// real major/minor boundary — see docs/archive/ironside-SNAPSHOT-2026-07-02.md for
// the full changelog). A concurrent session briefly labeled this same
// lineage "v0.3.0" before that renumbering was visible to it. This feature
// (Grade Model Feedback) was set as "Version v0.2.7" — the authoritative
// number, then bumped
// once more to v0.2.8 for the Grading Rubric page, per-brand Analytics,
// and the global feedback widget (same v0.2.x patch series — none of this
// has crossed a real major/minor boundary either). v0.2.9 continues the
// same series: the new Workflow section, the My Scripts persona-scoping
// fix + 3-zone redesign, colored editor sections, and real Organic India
// performance data are all additive to the existing product, not a
// structural break.
//
// v0.3.0 IS a real boundary: grading moved from a letter scale to 0-100
// (SUBMIT_THRESHOLD = 80).
// Every stored grade in ironside-script-data.ts was recomputed against the
// live grader, not hand-converted. Plus a new video grader (net-new
// capability, script grader never touched actual video before), a real
// AM+brand approval pipeline for video, a brand-facing portal with zero
// grades ever shown, and a creator FAQ/Lessons tab. This changes the
// product's core mental model (a number replacing a letter, a new grading
// domain), which is why it's a minor bump and not another 0.2.x patch.
//
// v0.3.1 — bug-fix/polish patch, no new domain. Fixes 5 issues found by an
// end-to-end "could a real, non-technical creator use this start to
// finish" walkthrough (2026-07-05), logged in full in
// docs/archive/ironside-SNAPSHOT-2026-07-05.md's v0.3.1 changelog entry:
//   1. Script Editor cold-opened to a hardcoded demo script (Jay Crotty's)
//      regardless of who was logged in — any other creator clicking
//      "Script Editor" landed on someone else's already-graded work, with
//      no real way to start a genuinely new script.
//   2. Zero mobile responsiveness — the sidebar had no breakpoints at all,
//      so on a phone it ate ~60% of the screen and pushed real content
//      (e.g. the Upload footage button) off-screen with no scroll cue.
//   3. A script's grade badge and its approval stage could visibly
//      disagree (e.g. a 42 sitting in "Approved") with zero explanation.
//   4. "This Week" still said "A-/Green" and "B-minus" — leftover letter-
//      grade copy from before the 0-100 rewrite, everywhere else in the
//      app (including the FAQ) already said "80".
//   5. The video QC self-report used unexplained jargon ("native TikTok
//      font", "middle third") with no tooltips, unlike every Script Editor
//      field, which has had them since v0.2.x.
export const APP_VERSION = "v0.3.1";
